import store from '@/store/store'
import { isMobile } from '@/util/index'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const user = store.state.userInfo

    if (value) {
      // platform 等于-1为平台方超管的特殊权限
      if (value.platform == -1 && (user.dealer_id != 0 || !user.is_super_admin)) {
        el.parentNode && el.parentNode.removeChild(el)
        return
      }

      // 判断权限所属平台 1 - 平台方， 2 - 中间商， 0 - 共用
      if ((value.platform == 1 && user.dealer_id > 0) || (value.platform == 2 && user.dealer_id == 0) || value.platform == 3) {
        el.parentNode && el.parentNode.removeChild(el)
        return
      }

      let userAuthCodes = []
      let codes = user.auth_codes
      if (codes && codes.length > 0) {
        // let arr = codes.filter(item => item.category == 1)
        userAuthCodes = codes[0].Codes
      }

      let code = value.pAuthCode
      if (isMobile()) {
        code = value.mAuthCode
      }

      if (code == "") {
        el.parentNode && el.parentNode.removeChild(el)
        return
      }

      const hasPermission = userAuthCodes.includes(code)
      if (!hasPermission && !user.is_super_admin) {
        el.parentNode && el.parentNode.removeChild(el)
        return
      }

    } else {
      // console.log("auth code error!")
      // throw new Error("auth code error!")
    }
  }
}
